module.exports = __webpack_public_path__ + "down-arrow.svg?291c60c56f8aced6761914bb659d77e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down-arrow.svg
// module id = 5
// module chunks = 0